import React from 'react';

import ItemMenu from './ItemMenu';

//
class Menu extends React.Component{
  constructor (props){
    super(props);
  }

  render() {
    const { dados } = this.props;
    const items = dados.items.map((x,i)=>{
      return <ItemMenu key={i} clickHandler={this.props.clickHandler} dados={x} />
    });
    return (
      <div className='menu-relatorios__box'>
        <div className='menu-relatorios__wrapper'>
          <div className='menu-relatorios__icon'><i className={dados.icon}></i></div>
          <div className='menu-relatorios__menu'>
            {items}
          </div>
          <div className='clear'></div>
        </div>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/classes/relatorios/Menu.js